import React, { useEffect, useState } from "react";

import axios from "axios";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { isProduct, ProductId } from "multitenancy/product";

import { useToast } from "hooks/toast";

import { updateCustomerCertificateAction } from "store/modules/customerCertificate/actions";
import { hideLoading, showLoading } from "store/modules/loading/actions";
import { SetUserCreateDistrict } from "store/modules/userCreateUnit/actions";
import { useAppSelector } from "store/rootReducer";

import { AdminArea } from "components/Body/AdminArea";
import { Drawer } from "components/Drawer";
import ModalDefault from "components/ModalDefault";

import { AttendantService } from "services/attendant";
import { AttendantRoleService } from "services/attendantRole";
import { CustomerCertificateService } from "services/customerCertificate";

import DateValidate from "utils/dateValidate";
import { FORMS_ADMIN } from "utils/entities/permission";
import { normalizeCpf, validateCpf } from "utils/validateCpf";
import { verifyEmailFormat } from "utils/verifyEmailFormat";

import {
  createNewUnityPost,
  createNewUserPost,
  updateUnityPut,
  updateUserPut,
} from "./service";
import { Container } from "./styles";
import { CreateUserComponent } from "../Unit/FormCreateUsers";
import { FormVinculeUnit } from "../Unit/FormCreateUsers/FormVinculeUnit";

export interface AttendantInterface {
  id: number;
  customerId: number;
  attendantRoleId: number;
  active: boolean;
  name: string;
  foreignKey?: string;
  createIn: Date;
  updateIn: Date;
}

export interface UserInterface {
  id: number;
  name: string;
  email: string;
  cpf?: string;
  document?: string;
  password: string;
  picture: null;
  customerId: number;
  emailValidated: true;
  termAccepted: true;
  createIn: string;
  updateIn: string;
  active: boolean;
}
interface ICustomerCertificate {
  id: string;
  cnpj: string;
  modality: string;
  title: string;
  description: string;
  amount: string;
  extraAmount: string;
  startDate: string;
  finishDate: string;
}

const CreateUsers: React.FC = () => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const { userCreateDistrictList } = useSelector(
    (state: any) => state.userCreateDistrict,
  );
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [unitOptions, setUnitOptions] = useState<any>([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [userIdEdit, setUserIdEdit] = useState(0);
  const [requiredEmail, setRequiredEmail] = useState(false);
  const [requiredName, setRequiredName] = useState(false);
  const [unitId, setUnitId] = useState<number>();
  const [isEditCreated, setIsEditCreated] = useState(false);
  const [profileLabel, setProfileLabel] = useState(undefined);
  const [requiredProfile, setRequiredProfile] = useState(false);
  const [requiredUnit, setRequiredunit] = useState(false);
  const [requiredCourt, setRequiredCourt] = useState(false);
  const [requiredCpf, setRequiredCpf] = useState(false);
  const [cpf, setCpf] = useState("");
  const [search, setSearch] = useState("");
  const [active, setActive] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openEmailChangeModal, setOpenEmailChangeModal] = useState(false);
  const [situation, setSituation] = useState<any>(2);
  const [listAttendant, setListAttendant] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [isActive, setIsActive] = useState(true);
  const [unitLabel, setUnitLabel] = useState(undefined);
  const [profileId, setProfileId] = useState<any>();
  const [expiredDate, setExpiredDate] = useState<any>();
  const [element, setElement] = useState<UserInterface>();
  const [extraContent, setExtraContent] = useState<any>();
  const [valueActive, setValueActive] = useState(false);
  const [updateItemId, setUpdateItemId] = useState<number>();
  const [customerCertificate, setCustomerCertificated] =
    useState<ICustomerCertificate>();

  const { userCustomerProfile } = useSelector((store: any) => store.profile);
  const [selectedType, setSelectedType] = useState<number | undefined>(
    profileId,
  );
  const [courtLabel, setCourtLabel] = useState<string | undefined>();
  const [courtId, setCourtId] = useState<any>();

  const { user } = useAppSelector((state) => state.user);
  const isCpfRequired = isProduct(ProductId.Audiencias);

  const handleChangeName = (value: string) => {
    setName(value);
    if (value.trim().length > 0) {
      setRequiredName(false);
    }
  };

  const handleChangeEmail = (value: string) => {
    setEmail(value);
    if (verifyEmailFormat(value.trim())) {
      setRequiredEmail(false);
    }
  };

  const handleChangeCpf = (value: string) => {
    setCpf(value.replace(/[^\d.-]+/g, ""));
    if (validateCpf(value)) {
      setRequiredCpf(false);
    }
  };

  const normalizeEmail = (value?: string) => value?.trim().toLowerCase() ?? "";
  const normalizeName = (value?: string) => value?.trim() ?? "";

  const hasChangedEmail = () =>
    isEdit &&
    typeof element?.email === "string" &&
    normalizeEmail(element.email) !== normalizeEmail(email);

  const hasInvalidCpf = (value: string) => {
    const hasCpfValue = normalizeCpf(value).length > 0;
    return (isCpfRequired || hasCpfValue) && !validateCpf(value);
  };

  const getCpfErrorMessage = (value: string) => {
    const hasCpfValue = normalizeCpf(value).length > 0;
    return hasCpfValue
      ? t("administration.users.messages.invalidCpfDesc")
      : t("administration.users.messages.fillRequired");
  };

  useEffect(() => {
    CustomerCertificateService.getAll(user?.customerId).then((response) => {
      setCustomerCertificated(response.data.data);
      dispatch(updateCustomerCertificateAction(response.data.data));
    });
  }, []);

  const filteredData =
    listAttendant?.filter((item: any) =>
      item?.name?.toLocaleLowerCase()?.includes(search.toLocaleLowerCase()),
    ) ?? [];

  const clear = () => {
    setOpenDrawer(false);
  };

  const getList = async () => {
    setLoading(true);

    if (user) {
      const response = await AttendantService.getAllUserCoustomer(
        user?.customerId,
        situation,
      );
      setListAttendant(response?.data?.data);
    }
    setLoading(false);
  };

  const isMasterProfile =
    userCustomerProfile?.profileType === 1 && userCustomerProfile?.active;

  const checkHaveMaster = () => {
    const mainProfile = userCreateDistrictList?.userData?.find(
      (item: any) => item?.type === 1 && item?.active === true,
    );
    const haveMaster = !!mainProfile;
    if (haveMaster) {
      setRequiredunit(false);
      return addToast({
        type: "warning",
        title: t("administration.units.create"),
        description: t("administration.units.messages.onlyOneProfileAllowed", {
          profile: mainProfile?.profile,
        }),
      });
    }

    setOpenDrawer(true);
  };

  const startAddNewUser = () => {
    dispatch(showLoading());
    setLoading(true);
    const normalizedName = normalizeName(name);
    const lowercasedEmail = normalizeEmail(email);

    if (!normalizedName || !lowercasedEmail || hasInvalidCpf(cpf)) {
      addToast({
        type: "warning",
        title: t("administration.users.create"),
        description: hasInvalidCpf(cpf)
          ? getCpfErrorMessage(cpf)
          : t("administration.users.messages.fillRequired"),
      });
      setRequiredName(!normalizedName);
      setRequiredEmail(!lowercasedEmail);
      setRequiredCpf(hasInvalidCpf(cpf));
      setLoading(false);
      dispatch(hideLoading());
      return;
    }

    if (!verifyEmailFormat(lowercasedEmail)) {
      addToast({
        type: "error",
        title: t("administration.users.messages.invalidEmail"),
        description: t("administration.users.messages.invalidEmailDesc"),
      });
      setRequiredEmail(true);
      setLoading(false);
      dispatch(hideLoading());
      return;
    }

    if (!isEdit && !isEditCreated) {
      createNewUserPost({
        name: normalizedName,
        email: lowercasedEmail,
        cpf,
        userCustomerId: user?.customerId,
        isActive,
        userCustomerProfile,
      }).then(async (item) => {
        if (item.status) {
          const responseGetAll = AttendantRoleService.getAllCustomerId(
            user?.customerId,
            1,
          );
          const filteredUser = (await responseGetAll).data.data.find(
            (userInList: any) => userInList.email === lowercasedEmail,
          );
          setUserIdEdit(filteredUser?.id);
          setRequiredName(false);
          setRequiredEmail(false);
          getList();
          setOpenDrawer(true);
          setIsEdit(true);
          addToast({
            type: "success",
            title: t("administration.users.create"),
            description: t("administration.users.messages.createdSuccess"),
          });
        } else {
          setLoading(false);
          const toastType = item.severity ?? "error";
          addToast({
            type: toastType as keyof typeof addToast,
            title: t("administration.users.create"),
            description: item.message,
          });
        }
        setLoading(false);
        dispatch(hideLoading());
      });
    } else {
      setOpenDrawer(true);
    }
  };

  async function onClick(item: UserInterface) {
    setUserIdEdit(item.id);
    setOpenModal(true);
    setName(item.name);
    setCpf(item?.cpf ?? item?.document ?? "");
    setIsActive(item.active);
    setElement(item);
    setExtraContent(item);
  }

  const createUnitPost = () => {
    checkHaveMaster();
    if (!profileLabel || !unitLabel) {
      addToast({
        type: "warning",
        title: t("administration.units.create"),
        description: t("administration.units.messages.fillRequired"),
      });
      setRequiredProfile(!profileLabel ? true : false);
      setRequiredunit(!unitLabel ? true : false);
      setRequiredCourt(selectedType === 0 && !courtLabel ? true : false);

      return;
    }

    const selectedPlaceId = selectedType === 0 ? courtId : unitId;
    const hasSelectedPlace =
      !!selectedPlaceId &&
      !!userCreateDistrictList?.userData?.some(
        (item: any) =>
          item?.unitId === selectedPlaceId ||
          item?.places?.some((place: any) => place?.id === selectedPlaceId),
      );

    if (hasSelectedPlace) {
      addToast({
        type: "warning",
        title: t("administration.units.create"),
        description: t("administration.units.messages.unitAlreadyLinked"),
      });
      return;
    }

    dispatch(showLoading());
    if (DateValidate(expiredDate)) {
      addToast({
        type: "warning" as keyof typeof addToast,
        title: t("administration.units.create"),
        description: t("administration.units.messages.datePastError"),
      });

      return;
    }

    if (profileLabel && unitOptions && unitOptions?.length <= 0) {
      addToast({
        type: "warning",
        title: t("administration.units.create"),
        description: t("administration.units.messages.noDistrictAvailable"),
      });
      setRequiredunit(false);

      return;
    }
    createNewUnityPost({
      userId: userIdEdit,
      unitId: selectedType === 0 ? courtId : unitId,
      profileId,
      expiredDate,
      active,
      userCustomerProfile,
    })
      .then(async (item) => {
        if (item.ok === true) {
          resetToInitialData();
          setOpenDrawer(false);
          const { data } = await AttendantRoleService.getAllByUser(userIdEdit);
          dispatch(
            SetUserCreateDistrict({
              userData: data?.data,
              errorName: !name,
              errorEmail: !email,
            }),
          );
          addToast({
            type: "success",
            title: t("administration.units.register"),
            description: t("administration.units.messages.registeredSuccess"),
          });
        } else {
          if (
            !profileLabel ||
            !unitLabel ||
            (selectedType === 0 && !courtLabel)
          ) {
            setRequiredProfile(!profileLabel ? true : false);
            setRequiredunit(!unitLabel ? true : false);
            setRequiredCourt(selectedType === 0 && !courtLabel ? true : false);

            addToast({
              type: "warning",
              title: t("administration.units.create"),
              description: t("administration.units.messages.fillRequiredAdd"),
            });

            return;
          }
        }
        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());
        addToast({
          type: "error",
          title: t("common.unexpectedError"),
          description: error.message,
        });
      });
  };

  const updateUser = async () => {
    const normalizedName = normalizeName(name);
    const lowercasedEmail = normalizeEmail(email);

    if (!normalizedName || !lowercasedEmail || hasInvalidCpf(cpf)) {
      addToast({
        type: "warning",
        title: t("administration.users.create"),
        description: hasInvalidCpf(cpf)
          ? getCpfErrorMessage(cpf)
          : t("administration.users.messages.fillRequired"),
      });
      setRequiredName(!normalizedName);
      setRequiredEmail(!lowercasedEmail);
      setRequiredCpf(hasInvalidCpf(cpf));
      return;
    }

    if (!verifyEmailFormat(lowercasedEmail)) {
      addToast({
        type: "error",
        title: t("administration.users.messages.invalidEmail"),
        description: t("administration.users.messages.invalidEmailDesc"),
      });
      setRequiredEmail(true);
      return;
    }

    if (
      customerCertificate &&
      customerCertificate.title === "Cadastro ativo" &&
      filteredData.length >= customerCertificate.amount + 1
    ) {
      addToast({
        type: "warning",
        title: t("administration.users.register"),
        description: t("administration.users.messages.maxLimitReached"),
      });
      return;
    }

    setRequiredName(false);
    setRequiredEmail(false);
    setRequiredCpf(false);

    updateUserPut({
      element,
      userCustomerId: user?.customerId,
      isActive,
      name: normalizedName,
      email: lowercasedEmail,
      cpf,
      userCustomerProfile,
      userId: userIdEdit,
    })
      .then((item) => {
        dispatch(showLoading());
        addToast({
          type: item.status ? "success" : "error",
          title: t("administration.users.updated"),
          description: item.message,
        });

        if (item.status) {
          dispatch(showLoading());
          resetToInitialData();
          setOpenModal(false);
          dispatch(hideLoading());
          getList();
          setIsEditCreated(false);
        } else {
          if (!name) {
            setRequiredName(true);
          }
        }
        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());
        addToast({
          type: "error",
          title: t("common.unexpectedError"),
          description: error.message,
        });
      });
  };

  const handleApplyUser = () => {
    const normalizedName = normalizeName(name);
    const lowercasedEmail = normalizeEmail(email);

    if (
      isEdit &&
      hasChangedEmail() &&
      !!normalizedName &&
      !!lowercasedEmail &&
      verifyEmailFormat(lowercasedEmail) &&
      !hasInvalidCpf(cpf)
    ) {
      setOpenEmailChangeModal(true);
      return;
    }

    if (isEdit) {
      updateUser();
      return;
    }

    startAddNewUser();
  };

  const updateUnit = async () => {
    if (DateValidate(expiredDate)) {
      addToast({
        type: "warning",
        title: t("administration.units.create"),
        description: t("administration.units.messages.datePastError"),
      });

      return;
    }
    updateUnityPut({
      updateItemId,
      userId: userIdEdit,
      unitId: selectedType === 0 ? courtId : unitId,
      profileId,
      expiredDate,
      active,
      userCustomerProfile,
    })
      .then(async (item) => {
        dispatch(showLoading());
        if (item.ok) {
          resetToInitialData();
          setOpenDrawer(false);
          const { data } = await AttendantRoleService.getAllByUser(userIdEdit);
          dispatch(
            SetUserCreateDistrict({
              userData: data?.data,
              errorName: !name,
              errorEmail: !email,
            }),
          );
          addToast({
            type: "success",
            title: t("administration.units.register"),
            description: item.message,
          });
          setIsEditCreated(false);
        }
        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());
        addToast({
          type: "error",
          title: t("common.unexpectedError"),
          description: error.message,
        });
      });
  };

  useEffect(() => {
    getList();
  }, [situation]);

  async function setActiveAction(action: any) {
    try {
      dispatch(showLoading());

      await AttendantService.putUnit(user?.id, valueActive);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.log(error.message);
      }
    }

    await handleSelectedAction(action);

    dispatch(hideLoading());
  }

  async function handleSelectedAction(item: any) {
    setUnitLabel(item.id && item.type === 0 ? item.places[0].name : item.place);
    setUnitId(item.unitId);
    setProfileLabel(item.profile);
    setProfileId(item.profileId);
    setCourtLabel(!item.id ? item.courtLabel : item.place);
    setCourtId(item.unitId);
    setExpiredDate(item.expireIn);
    setSelectedType(item.type);
    setActive(item.active);
    setOpenDrawer(true);
    setUpdateItemId(item.id);
    setIsEditCreated(true);
  }

  const resetToInitialData = () => {
    setProfileId(null);
    setProfileLabel(undefined);
    setUnitLabel(undefined);
    setExpiredDate(undefined);
    setCourtLabel(undefined);
    setRequiredEmail(false);
    setRequiredName(false);
    setIsActive(true);
    setRequiredProfile(false);
    setRequiredunit(false);
    setRequiredCourt(false);
    setRequiredCpf(false);
    setUnitId(undefined);
    setActive(true);
    setOpenEmailChangeModal(false);
  };

  const openComponentesClear = () => {
    setOpenDrawer(true);
    resetToInitialData();
  };

  const openModalCleared = () => {
    if (
      customerCertificate &&
      customerCertificate.title === "Cadastro ativo" &&
      filteredData.length >= customerCertificate.amount + 1
    ) {
      addToast({
        type: "warning",
        title: t("administration.users.register"),
        description: t("administration.users.messages.maxLimitReached"),
      });
      return;
    } else {
      dispatch(
        SetUserCreateDistrict({
          userData: [],
        }),
      );
      setIsEdit(false);
      setName("");
      setEmail("");
      setCpf("");
      setRequiredCpf(false);
      setActive(true);
      setIsActive(true);
      setElement(undefined);
      setExtraContent("");
      setOpenModal(true);
    }
  };

  const closeModal = () => {
    setOpenDrawer(false);
    resetToInitialData();
    setRequiredProfile(false);
    setRequiredunit(false);
    setRequiredCourt(false);
    setRequiredCpf(false);
    setActive(true);
    setIsEditCreated(false);
  };

  const closeFirstModal = () => {
    setOpenModal(false);
    setOpenEmailChangeModal(false);
    setIsEditCreated(false);
    setRequiredName(false);
    setRequiredEmail(false);
    setRequiredCpf(false);
    setCpf("");
  };

  return (
    <Container>
      <AdminArea
        loading={loading}
        title={t("administration.users.title")}
        InputSearchLabel={t("common.search")}
        InputSearchOnChange={(text) => setSearch(text)}
        searchText={search}
        list={filteredData}
        headerAddButtonOnClick={() => openModalCleared()}
        onClick={(item: any) => onClick(item)}
        setOpenModal={setOpenModal}
        onChangeSituation={(value: any) => setSituation(value)}
        permissionName={FORMS_ADMIN.USER_CUSTOMER}
        headerTrashButtonOnClick={function (): unknown {
          throw new Error("Function not implemented.");
        }}
        setItemReturnClick={setElement}
        setIsEdit={setIsEdit}
      />

      <Drawer
        title={
          isEdit
            ? t("administration.users.edit")
            : t("administration.users.register")
        }
        open={openModal}
        paddingLeft={30}
        paddingRight={30}
        onClose={() => {
          closeFirstModal();
          clear();
        }}
        onApply={handleApplyUser}
      >
        <CreateUserComponent
          onClickDelete={setActiveAction}
          items={(value: any) => setValueActive(value)}
          onClick={(item: any) => handleSelectedAction(item)}
          email={email}
          cpf={cpf}
          isActive={isActive}
          name={name}
          onChangeEmail={handleChangeEmail}
          onChangeCpf={handleChangeCpf}
          onChangeName={handleChangeName}
          onChangeSwitch={setIsActive}
          userId={element?.id}
          openModalVincule={!isEdit ? startAddNewUser : () => checkHaveMaster()}
          userCreateDistrictList={userCreateDistrictList}
          errorEmail={requiredEmail}
          errorName={requiredName}
          errorCpf={requiredCpf}
          onChangeExtraContent={(e) => setExtraContent(e)}
          extraContent={extraContent}
          isEdit={isEdit}
          isEditCreated={isEditCreated}
          isMasterProfile={isMasterProfile}
        />
      </Drawer>

      <ModalDefault
        openModal={openEmailChangeModal}
        setOpenModal={setOpenEmailChangeModal}
        title={t("common.warning")}
        bodyMessageTitle={
          <Trans
            i18nKey="administration.users.messages.emailChangedWarning"
            values={{
              from: element?.email,
              to: normalizeEmail(email),
            }}
            components={{
              b: <strong />,
              strong: <strong />,
            }}
          />
        }
        bodyMessageSubTitle={t(
          "administration.users.messages.emailChangedConfirm",
        )}
        textConfirm={t("common.apply")}
        onClickConfirm={() => {
          setOpenEmailChangeModal(false);
          updateUser();
        }}
        textCancel={t("common.cancel").toUpperCase()}
        onClickCancel={() => setOpenEmailChangeModal(false)}
      />

      <Drawer
        title={t("administration.units.data")}
        open={openDrawer}
        onClose={() => closeModal()}
        onApply={isEdit && !isEditCreated ? createUnitPost : updateUnit}
        paddingLeft={30}
        paddingRight={30}
      >
        <FormVinculeUnit
          customerId={user?.customerId}
          setProfileId={setProfileId}
          setProfileLabel={setProfileLabel}
          setUnitLabel={setUnitLabel}
          unitLabel={unitLabel}
          expiredDate={expiredDate}
          setExpiredDate={setExpiredDate}
          active={active}
          onChangeSwitch={() => setActive(!active)}
          onSelectType={(selectedType) => setUnitId(selectedType)}
          userId={user?.id}
          isEditCreated={isEditCreated}
          isEdit={isEdit}
          profileLabel={profileLabel}
          setSelectedType={setSelectedType}
          selectedType={selectedType}
          setCourtLabel={setCourtLabel}
          setCourtId={setCourtId}
          courtLabel={courtLabel}
          userIdEdit={userIdEdit}
          requiredProfile={requiredProfile}
          requiredUnit={requiredUnit}
          requiredCourt={requiredCourt}
          setUnitOptions={setUnitOptions}
        />
      </Drawer>
    </Container>
  );
};

export default CreateUsers;
